module.exports = __webpack_public_path__ + "static/media/people.e9acf358.jpg";